<template>
    <div class="account-pages my-5 pt-sm-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10 col-xl-8">
                    <div class="card overflow-hidden">
                        <div class="bg-soft bg-white border-bottom" style="border-color:#b7b7b7!important">
                            <div class="row g-0">
                                <div class="col-12 col-md-7 order-2 order-md-1">
                                    <div class="p-4" v-if="ready">
                                        <h2 class="text-primary">Packing Overview</h2>
                                        <h4 class="mb-4">{{ requestData.client_name }}</h4>
                                        <dl class="row">
                                            <dt class="col-sm-5">Stock UID:</dt>
                                            <dd class="col-sm-7">{{ requestData.tag_id }}</dd>
                                            
                                            <dt class="col-sm-5">Batch No:</dt>
                                            <dd class="col-sm-7">{{ requestData.batch_no ?? "Not Provided" }}</dd>

                                            <dt class="col-sm-5">Batch UID:</dt>
                                            <dd class="col-sm-7">{{ requestData.batch_id ?? "Not Provided"}}</dd>

                                            <dt class="col-sm-5">Cultivar:</dt>
                                            <dd class="col-sm-7">{{ requestData.cultivar_name }}</dd>

                                            <dt class="col-sm-5">Packaged Net Mass:</dt>
                                            <dd class="col-sm-7">{{ requestData.net_mass }}g</dd>

                                            <dt class="col-sm-5">Packaged Date:</dt>
                                            <dd class="col-sm-7">{{ requestData.packaged_date }}</dd>

                                            <dt class="col-sm-5">Expiry Date:</dt>
                                            <dd class="col-sm-7">{{ requestData.expiry_date }}</dd>
                                        </dl>
                                        
                                        <div class="mt-4 d-grid">
                                            <button class="btn btn-primary" type="button" @click="requestCOA()">
                                                Download COA Files
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-5 order-1 order-md-2 align-self-center text-center p-4">
                                    <img
                                        :src="logoImg"
                                        alt="Client Logo"
                                        class="img-fluid clientLogo"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div class="p-2">
                                <div class="mt-4 text-center">
                                    <p class="mb-0">
                                        © {{ new Date().getFullYear() }} CCB IT
                                    </p>
                                </div>
                            </div>
                            <b-overlay :show="!tokenValid" no-wrap>
                                <template #overlay>
                                    <div class="text-center">
                                        <i style="font-size: 4rem; color: red;" class="fas fa-exclamation-triangle"></i>
                                        <h2 id="cancel-label">Token Expired</h2>
                                    </div>
                                </template>
                            </b-overlay>
                            <b-overlay :show="!ready" no-wrap></b-overlay>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
/* OPTIMIZATION: Simplified CSS. */
/* 'img-fluid' from Bootstrap handles responsiveness. */
/* We only constrain the max-height as per the original design. */
.clientLogo {
    max-height: 250px;
    /* The 'img-fluid' class handles max-width: 100% and height: auto */
}
</style>

<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';

export default {
    page: {
        title: "Stock Overview",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            ready: false,
            tokenValid: true,
            requestData: {}, // Initialize as an object
        };
    },
    computed: {
        logoImg() {
            // Check if requestData and client_logo are available
            if (this.ready && this.requestData && this.requestData.client_logo) {
                return this.requestData.client_logo;
            }
            // Fallback logo
            return "/img/ccb_fixed_logo.2df32e54.png";
        }
    },
    methods: {
        fetchRequestData() {
            this.ready = false;
            axios.get('api/ext/batchstockoverview/' + this.$route.params.token)
            .then(response => {
                this.requestData = response.data;
                this.ready = true;
            })
            //eslint-disable-next-line no-unused-vars
            .catch(e => {
                this.tokenValid = false;
                this.ready = true; // Still set to true to hide loader and show error
            })
        },
        requestCOA() {
            if (this.requestData.batch_coas && this.requestData.batch_coas.length > 0) {
                // Using forEach directly is cleaner than with lodash here
                this.requestData.batch_coas.forEach(value => {
                    const src = process.env.VUE_APP_API_BASEURL + value.coa_src;
                    window.open(src, "_blank");
                });
            } else {
                Swal.fire("No COA Files Found", "There are no active COA's for this stock. Please contact " + this.requestData.client_name, "error");
            }
        }
    },
    mounted() {
        this.fetchRequestData();
    },
};
</script>